'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contacts = require('./contacts.html');

var _contacts2 = _interopRequireDefault(_contacts);

var _contactDetail = require('./contactDetail.html');

var _contactDetail2 = _interopRequireDefault(_contactDetail);

var _contactAdd = require('./contactAdd.html');

var _contactAdd2 = _interopRequireDefault(_contactAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
var ContactsConfig = function ContactsConfig($stateProvider) {
  $stateProvider.state('contacts', {
    url: '/contacts',
    template: _contacts2.default,
    controller: 'ContactsController',
    controllerAs: 'contacts',
    params: { campaignId: null, defaultTab: 'PACKAGE', callingPage: null }
  }).state('contactAdd', {
    url: '/contacts/add',
    template: _contactAdd2.default,
    controller: 'ContactAddController',
    controllerAs: 'contactAdd',
    params: { investor: null, customCount: null, advindaCount: null }
  }).state('contactEdit', {
    url: '/contacts/edit/:contactId',
    template: _contactAdd2.default,
    controller: 'ContactAddController',
    controllerAs: 'contactAdd',
    params: { customCount: null, advindaCount: null }
  }).state('contactsDetail', {
    url: '/contacts/:contactId',
    template: _contactDetail2.default,
    controller: 'ContactDetailController',
    controllerAs: 'contact',
    params: { isCustomerContact: false, customCount: null, advindaCount: null }
  }).state('customerContactsDetail', {
    url: '/contacts/customerContacts/:contactId',
    template: _contactDetail2.default,
    controller: 'ContactDetailController',
    controllerAs: 'contact',
    params: { isCustomerContact: true, customCount: null, advindaCount: null }
  });
};

exports.default = ContactsConfig;


/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contacts.config.js
 **/